import { formatCookie } from "./util.js";

//#region ../../node_modules/@jwplayer/fe-common/module/cookies/index.js
const documentCookie = (() => {
	let mockCookie = "";
	return {
		set(value) {
			if (typeof document === "undefined" || typeof document.cookie === "undefined") mockCookie = value;
			else document.cookie = value;
		},
		get() {
			if (typeof document === "undefined" || typeof document.cookie === "undefined") return mockCookie;
			return document.cookie;
		}
	};
})();
/**
* Set a cookie
*/
function setCookie(key, value, config) {
	const cookieString = formatCookie(key, value, config);
	documentCookie.set(cookieString);
}
/**
* Delete a cookie
*/
function deleteCookie(key, config) {
	documentCookie.set(formatCookie(key, "", {
		...config,
		"Max-Age": -999999
	}));
}
/**
* Get a cookie's value
*/
function getCookie(key) {
	const cookies = documentCookie.get().split(";").map((i) => i.trim());
	for (const cookie of cookies) {
		const parts = cookie.split("=");
		if (parts.length < 2) continue;
		if (parts.shift() === key) return parts.join("=");
	}
}
function createCookieManager(config) {
	let _config = config;
	return {
		setConfig(config$1) {
			_config = config$1;
		},
		getCookie,
		setCookie: (key, value, config$1) => {
			setCookie(key, value, {
				...config$1,
				..._config
			});
		},
		deleteCookie: (key, config$1) => {
			deleteCookie(key, {
				...config$1,
				..._config
			});
		},
		getConfig() {
			return { ..._config };
		}
	};
}

//#endregion
export { createCookieManager };